module.exports = __webpack_public_path__ + "img/s9+.57946358.png";